/// CSS
import '../sass/guest.scss';

/// Vendor
import './vendor';

/// Custom
import './guest/custom';

/// Vue Components
import SweetAlert from './shared/components/SweetAlert.vue';
//import ExampleComponent from './guest/components/ExampleComponent.vue';

const app = vueApp({});
app.component('sweet', SweetAlert);
//app.component('example-component', ExampleComponent);
app.mount('#app');